export enum TemplateType {
  gritLeadership,
  noGridNoCoach,
  noGrid,
}

export class TemplateTypeUtil {
  public static templateTypeToString(mode: TemplateType): string {
    return TemplateType[mode];
  }
}


// WEBPACK FOOTER //
// ./src/api/types/TemplateType.ts